/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* GRL_MODIFY: Modified from codegen version. GRL_MODIFY marks changes
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/
/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  SelectField,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { ReductionAccountEntry } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function ReductionAccountEntryCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    presets, // GRL_MODIFY: add presets prop
    ...rest
  } = props;
  const initialValues = {
    ReductionInitiativeName: "",
    ReductionInitiativeStatus: "",
    ReductionInitiativeDescription: "",
    EmissionReductionUnit: "",
    EmissionReductionValue: "",
    EstimatedAnnualCO2Saving: "",
    CO2SavingScope: "",
    InitiativeStartDate: "",
    InitiativeEndDate: "",
    AnnualMonetarySaving: "",
    PaybackPeriod: "",
    RequiredInvestment: "",
    EstimatedInitiativeLifetime: "",
    GrossEmissionReductionAchieved: "",
    DateAchieved: "",
    ...presets // GRL_MODIFY: add presets to initial values
  };
  const [ReductionInitiativeName, setReductionInitiativeName] = React.useState(
    initialValues.ReductionInitiativeName
  );
  const [ReductionInitiativeStatus, setReductionInitiativeStatus] =
    React.useState(initialValues.ReductionInitiativeStatus);
  const [ReductionInitiativeDescription, setReductionInitiativeDescription] =
    React.useState(initialValues.ReductionInitiativeDescription);
  const [EmissionReductionUnit, setEmissionReductionUnit] = React.useState(
    initialValues.EmissionReductionUnit
  );
  const [EmissionReductionValue, setEmissionReductionValue] = React.useState(
    initialValues.EmissionReductionValue
  );
  const [EstimatedAnnualCO2Saving, setEstimatedAnnualCO2Saving] =
    React.useState(initialValues.EstimatedAnnualCO2Saving);
  const [CO2SavingScope, setCO2SavingScope] = React.useState(
    initialValues.CO2SavingScope
  );
  const [InitiativeStartDate, setInitiativeStartDate] = React.useState(
    initialValues.InitiativeStartDate
  );
  const [InitiativeEndDate, setInitiativeEndDate] = React.useState(
    initialValues.InitiativeEndDate
  );
  const [AnnualMonetarySaving, setAnnualMonetarySaving] = React.useState(
    initialValues.AnnualMonetarySaving
  );
  const [PaybackPeriod, setPaybackPeriod] = React.useState(
    initialValues.PaybackPeriod
  );
  const [RequiredInvestment, setRequiredInvestment] = React.useState(
    initialValues.RequiredInvestment
  );
  const [EstimatedInitiativeLifetime, setEstimatedInitiativeLifetime] =
    React.useState(initialValues.EstimatedInitiativeLifetime);
  const [GrossEmissionReductionAchieved, setGrossEmissionReductionAchieved] =
    React.useState(initialValues.GrossEmissionReductionAchieved);
  const [DateAchieved, setDateAchieved] = React.useState(
    initialValues.DateAchieved
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setReductionInitiativeName(initialValues.ReductionInitiativeName);
    setReductionInitiativeStatus(initialValues.ReductionInitiativeStatus);
    setReductionInitiativeDescription(
      initialValues.ReductionInitiativeDescription
    );
    setEmissionReductionUnit(initialValues.EmissionReductionUnit);
    setEmissionReductionValue(initialValues.EmissionReductionValue);
    setEstimatedAnnualCO2Saving(initialValues.EstimatedAnnualCO2Saving);
    setCO2SavingScope(initialValues.CO2SavingScope);
    setInitiativeStartDate(initialValues.InitiativeStartDate);
    setInitiativeEndDate(initialValues.InitiativeEndDate);
    setAnnualMonetarySaving(initialValues.AnnualMonetarySaving);
    setPaybackPeriod(initialValues.PaybackPeriod);
    setRequiredInvestment(initialValues.RequiredInvestment);
    setEstimatedInitiativeLifetime(initialValues.EstimatedInitiativeLifetime);
    setGrossEmissionReductionAchieved(
      initialValues.GrossEmissionReductionAchieved
    );
    setDateAchieved(initialValues.DateAchieved);
    setErrors({});
  };
  const validations = {
    ReductionInitiativeName: [],
    ReductionInitiativeStatus: [],
    ReductionInitiativeDescription: [],
    EmissionReductionUnit: [],
    EmissionReductionValue: [],
    EstimatedAnnualCO2Saving: [],
    CO2SavingScope: [],
    InitiativeStartDate: [],
    InitiativeEndDate: [],
    AnnualMonetarySaving: [],
    PaybackPeriod: [],
    RequiredInvestment: [],
    EstimatedInitiativeLifetime: [],
    GrossEmissionReductionAchieved: [],
    DateAchieved: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          ReductionInitiativeName,
          ReductionInitiativeStatus,
          ReductionInitiativeDescription,
          EmissionReductionUnit,
          EmissionReductionValue,
          EstimatedAnnualCO2Saving,
          CO2SavingScope,
          InitiativeStartDate,
          InitiativeEndDate,
          AnnualMonetarySaving,
          PaybackPeriod,
          RequiredInvestment,
          EstimatedInitiativeLifetime,
          GrossEmissionReductionAchieved,
          DateAchieved,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new ReductionAccountEntry(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "ReductionAccountEntryCreateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Greenhouse Gas Emission Reduction Transaction"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 23."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Heading>
      <Text
        children="Create a record describing an initiative to reduce CO2 emissions."
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <TextField
        label="Reduction initiative name"
        isRequired={false}
        isReadOnly={false}
        value={ReductionInitiativeName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ReductionInitiativeName: value,
              ReductionInitiativeStatus,
              ReductionInitiativeDescription,
              EmissionReductionUnit,
              EmissionReductionValue,
              EstimatedAnnualCO2Saving,
              CO2SavingScope,
              InitiativeStartDate,
              InitiativeEndDate,
              AnnualMonetarySaving,
              PaybackPeriod,
              RequiredInvestment,
              EstimatedInitiativeLifetime,
              GrossEmissionReductionAchieved,
              DateAchieved,
            };
            const result = onChange(modelFields);
            value = result?.ReductionInitiativeName ?? value;
          }
          if (errors.ReductionInitiativeName?.hasError) {
            runValidationTasks("ReductionInitiativeName", value);
          }
          setReductionInitiativeName(value);
        }}
        onBlur={() =>
          runValidationTasks("ReductionInitiativeName", ReductionInitiativeName)
        }
        errorMessage={errors.ReductionInitiativeName?.errorMessage}
        hasError={errors.ReductionInitiativeName?.hasError}
        {...getOverrideProps(overrides, "ReductionInitiativeName")}
      ></TextField>
      <SelectField
        label="Reduction initiative status"
        placeholder="Please select an option"
        isDisabled={false}
        value={ReductionInitiativeStatus}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ReductionInitiativeName,
              ReductionInitiativeStatus: value,
              ReductionInitiativeDescription,
              EmissionReductionUnit,
              EmissionReductionValue,
              EstimatedAnnualCO2Saving,
              CO2SavingScope,
              InitiativeStartDate,
              InitiativeEndDate,
              AnnualMonetarySaving,
              PaybackPeriod,
              RequiredInvestment,
              EstimatedInitiativeLifetime,
              GrossEmissionReductionAchieved,
              DateAchieved,
            };
            const result = onChange(modelFields);
            value = result?.ReductionInitiativeStatus ?? value;
          }
          if (errors.ReductionInitiativeStatus?.hasError) {
            runValidationTasks("ReductionInitiativeStatus", value);
          }
          setReductionInitiativeStatus(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "ReductionInitiativeStatus",
            ReductionInitiativeStatus
          )
        }
        errorMessage={errors.ReductionInitiativeStatus?.errorMessage}
        hasError={errors.ReductionInitiativeStatus?.hasError}
        {...getOverrideProps(overrides, "ReductionInitiativeStatus")}
      >
        <option
          children="Investigating"
          value="Investigating"
          {...getOverrideProps(overrides, "ReductionInitiativeStatusoption0")}
        ></option>
        <option
          children="Planning"
          value="Planning"
          {...getOverrideProps(overrides, "ReductionInitiativeStatusoption1")}
        ></option>
        <option
          children="Implementing"
          value="Implementing"
          {...getOverrideProps(overrides, "ReductionInitiativeStatusoption2")}
        ></option>
        <option
          children="Implemented"
          value="Implemented"
          {...getOverrideProps(overrides, "ReductionInitiativeStatusoption3")}
        ></option>
      </SelectField>
      <TextAreaField
        label="Reduction initiative description"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ReductionInitiativeName,
              ReductionInitiativeStatus,
              ReductionInitiativeDescription: value,
              EmissionReductionUnit,
              EmissionReductionValue,
              EstimatedAnnualCO2Saving,
              CO2SavingScope,
              InitiativeStartDate,
              InitiativeEndDate,
              AnnualMonetarySaving,
              PaybackPeriod,
              RequiredInvestment,
              EstimatedInitiativeLifetime,
              GrossEmissionReductionAchieved,
              DateAchieved,
            };
            const result = onChange(modelFields);
            value = result?.ReductionInitiativeDescription ?? value;
          }
          if (errors.ReductionInitiativeDescription?.hasError) {
            runValidationTasks("ReductionInitiativeDescription", value);
          }
          setReductionInitiativeDescription(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "ReductionInitiativeDescription",
            ReductionInitiativeDescription
          )
        }
        errorMessage={errors.ReductionInitiativeDescription?.errorMessage}
        hasError={errors.ReductionInitiativeDescription?.hasError}
        	value={ReductionInitiativeDescription} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "ReductionInitiativeDescription")}
      ></TextAreaField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid7")}
      >
        <SelectField
          label="Emission reduction unit"
          placeholder="Please select an option"
          isDisabled={false}
          value={EmissionReductionUnit}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit: value,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving,
                CO2SavingScope,
                InitiativeStartDate,
                InitiativeEndDate,
                AnnualMonetarySaving,
                PaybackPeriod,
                RequiredInvestment,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.EmissionReductionUnit ?? value;
            }
            if (errors.EmissionReductionUnit?.hasError) {
              runValidationTasks("EmissionReductionUnit", value);
            }
            setEmissionReductionUnit(value);
          }}
          onBlur={() =>
            runValidationTasks("EmissionReductionUnit", EmissionReductionUnit)
          }
          errorMessage={errors.EmissionReductionUnit?.errorMessage}
          hasError={errors.EmissionReductionUnit?.hasError}
          {...getOverrideProps(overrides, "EmissionReductionUnit")}
        >
          <option
            children="Employees"
            value="Employees"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption0")}
          ></option>
          <option
            children="Kg"
            value="Kg"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption1")}
          ></option>
          <option
            children="Kw"
            value="Kw"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption2")}
          ></option>
          <option
            children="Kwh"
            value="Kwh"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption3")}
          ></option>
          <option
            children="Litres"
            value="Litres"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption4")}
          ></option>
          <option
            children="Metres cubed"
            value="MetresCubed"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption5")}
          ></option>
          <option
            children="Million dollars revenue"
            value="MillionDollarsRevenue"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption6")}
          ></option>
          <option
            children="Nights"
            value="Nights"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption7")}
          ></option>
          <option
            children="Passenger per km"
            value="PassengerPerKm"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption8")}
          ></option>
          <option
            children="Per capita"
            value="PerCapita"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption9")}
          ></option>
          <option
            children="Percentage"
            value="Percentage"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption10")}
          ></option>
          <option
            children="Quantity"
            value="Quantity"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption11")}
          ></option>
          <option
            children="Tonnes"
            value="Tonnes"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption12")}
          ></option>
          <option
            children="Tonnes per km"
            value="TonnesPerKm"
            {...getOverrideProps(overrides, "EmissionReductionUnitoption13")}
          ></option>
        </SelectField>
        <TextField
          label="Emission reduction value"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={EmissionReductionValue}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue: value,
                EstimatedAnnualCO2Saving,
                CO2SavingScope,
                InitiativeStartDate,
                InitiativeEndDate,
                AnnualMonetarySaving,
                PaybackPeriod,
                RequiredInvestment,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.EmissionReductionValue ?? value;
            }
            if (errors.EmissionReductionValue?.hasError) {
              runValidationTasks("EmissionReductionValue", value);
            }
            setEmissionReductionValue(value);
          }}
          onBlur={() =>
            runValidationTasks("EmissionReductionValue", EmissionReductionValue)
          }
          errorMessage={errors.EmissionReductionValue?.errorMessage}
          hasError={errors.EmissionReductionValue?.hasError}
          {...getOverrideProps(overrides, "EmissionReductionValue")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid8")}
      >
        <TextField
          label="Estimated annual kg CO2e saving"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={EstimatedAnnualCO2Saving}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving: value,
                CO2SavingScope,
                InitiativeStartDate,
                InitiativeEndDate,
                AnnualMonetarySaving,
                PaybackPeriod,
                RequiredInvestment,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.EstimatedAnnualCO2Saving ?? value;
            }
            if (errors.EstimatedAnnualCO2Saving?.hasError) {
              runValidationTasks("EstimatedAnnualCO2Saving", value);
            }
            setEstimatedAnnualCO2Saving(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "EstimatedAnnualCO2Saving",
              EstimatedAnnualCO2Saving
            )
          }
          errorMessage={errors.EstimatedAnnualCO2Saving?.errorMessage}
          hasError={errors.EstimatedAnnualCO2Saving?.hasError}
          {...getOverrideProps(overrides, "EstimatedAnnualCO2Saving")}
        ></TextField>
        <SelectField
          label="Emissions scope"
          placeholder="Please select an option"
          isDisabled={false}
          value={CO2SavingScope}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving,
                CO2SavingScope: value,
                InitiativeStartDate,
                InitiativeEndDate,
                AnnualMonetarySaving,
                PaybackPeriod,
                RequiredInvestment,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.CO2SavingScope ?? value;
            }
            if (errors.CO2SavingScope?.hasError) {
              runValidationTasks("CO2SavingScope", value);
            }
            setCO2SavingScope(value);
          }}
          onBlur={() => runValidationTasks("CO2SavingScope", CO2SavingScope)}
          errorMessage={errors.CO2SavingScope?.errorMessage}
          hasError={errors.CO2SavingScope?.hasError}
          {...getOverrideProps(overrides, "CO2SavingScope")}
        >
          <option
            children="Scope 1"
            value="Scope_1"
            {...getOverrideProps(overrides, "CO2SavingScopeoption0")}
          ></option>
          <option
            children="Scope 2"
            value="Scope_2"
            {...getOverrideProps(overrides, "CO2SavingScopeoption1")}
          ></option>
          <option
            children="Scope 3"
            value="Scope_3"
            {...getOverrideProps(overrides, "CO2SavingScopeoption2")}
          ></option>
        </SelectField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid9")}
      >
        <TextField
          label="Initiative start date"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={InitiativeStartDate}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving,
                CO2SavingScope,
                InitiativeStartDate: value,
                InitiativeEndDate,
                AnnualMonetarySaving,
                PaybackPeriod,
                RequiredInvestment,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.InitiativeStartDate ?? value;
            }
            if (errors.InitiativeStartDate?.hasError) {
              runValidationTasks("InitiativeStartDate", value);
            }
            setInitiativeStartDate(value);
          }}
          onBlur={() =>
            runValidationTasks("InitiativeStartDate", InitiativeStartDate)
          }
          errorMessage={errors.InitiativeStartDate?.errorMessage}
          hasError={errors.InitiativeStartDate?.hasError}
          {...getOverrideProps(overrides, "InitiativeStartDate")}
        ></TextField>
        <TextField
          label="Initiative end date"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={InitiativeEndDate}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving,
                CO2SavingScope,
                InitiativeStartDate,
                InitiativeEndDate: value,
                AnnualMonetarySaving,
                PaybackPeriod,
                RequiredInvestment,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.InitiativeEndDate ?? value;
            }
            if (errors.InitiativeEndDate?.hasError) {
              runValidationTasks("InitiativeEndDate", value);
            }
            setInitiativeEndDate(value);
          }}
          onBlur={() =>
            runValidationTasks("InitiativeEndDate", InitiativeEndDate)
          }
          errorMessage={errors.InitiativeEndDate?.errorMessage}
          hasError={errors.InitiativeEndDate?.hasError}
          {...getOverrideProps(overrides, "InitiativeEndDate")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid10")}
      >
        <TextField
          label="Annual monetary saving"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={AnnualMonetarySaving}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving,
                CO2SavingScope,
                InitiativeStartDate,
                InitiativeEndDate,
                AnnualMonetarySaving: value,
                PaybackPeriod,
                RequiredInvestment,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.AnnualMonetarySaving ?? value;
            }
            if (errors.AnnualMonetarySaving?.hasError) {
              runValidationTasks("AnnualMonetarySaving", value);
            }
            setAnnualMonetarySaving(value);
          }}
          onBlur={() =>
            runValidationTasks("AnnualMonetarySaving", AnnualMonetarySaving)
          }
          errorMessage={errors.AnnualMonetarySaving?.errorMessage}
          hasError={errors.AnnualMonetarySaving?.hasError}
          {...getOverrideProps(overrides, "AnnualMonetarySaving")}
        ></TextField>
        <TextField
          label="Payback period"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={PaybackPeriod}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving,
                CO2SavingScope,
                InitiativeStartDate,
                InitiativeEndDate,
                AnnualMonetarySaving,
                PaybackPeriod: value,
                RequiredInvestment,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.PaybackPeriod ?? value;
            }
            if (errors.PaybackPeriod?.hasError) {
              runValidationTasks("PaybackPeriod", value);
            }
            setPaybackPeriod(value);
          }}
          onBlur={() => runValidationTasks("PaybackPeriod", PaybackPeriod)}
          errorMessage={errors.PaybackPeriod?.errorMessage}
          hasError={errors.PaybackPeriod?.hasError}
          {...getOverrideProps(overrides, "PaybackPeriod")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid11")}
      >
        <TextField
          label="Required investment"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={RequiredInvestment}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving,
                CO2SavingScope,
                InitiativeStartDate,
                InitiativeEndDate,
                AnnualMonetarySaving,
                PaybackPeriod,
                RequiredInvestment: value,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.RequiredInvestment ?? value;
            }
            if (errors.RequiredInvestment?.hasError) {
              runValidationTasks("RequiredInvestment", value);
            }
            setRequiredInvestment(value);
          }}
          onBlur={() =>
            runValidationTasks("RequiredInvestment", RequiredInvestment)
          }
          errorMessage={errors.RequiredInvestment?.errorMessage}
          hasError={errors.RequiredInvestment?.hasError}
          {...getOverrideProps(overrides, "RequiredInvestment")}
        ></TextField>
        <TextField
          label="Estimated initiative lifetime"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={EstimatedInitiativeLifetime}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving,
                CO2SavingScope,
                InitiativeStartDate,
                InitiativeEndDate,
                AnnualMonetarySaving,
                PaybackPeriod,
                RequiredInvestment,
                EstimatedInitiativeLifetime: value,
                GrossEmissionReductionAchieved,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.EstimatedInitiativeLifetime ?? value;
            }
            if (errors.EstimatedInitiativeLifetime?.hasError) {
              runValidationTasks("EstimatedInitiativeLifetime", value);
            }
            setEstimatedInitiativeLifetime(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "EstimatedInitiativeLifetime",
              EstimatedInitiativeLifetime
            )
          }
          errorMessage={errors.EstimatedInitiativeLifetime?.errorMessage}
          hasError={errors.EstimatedInitiativeLifetime?.hasError}
          {...getOverrideProps(overrides, "EstimatedInitiativeLifetime")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid12")}
      >
        <TextField
          label="Gross emission reduction achieved (kg CO2e)"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={GrossEmissionReductionAchieved}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving,
                CO2SavingScope,
                InitiativeStartDate,
                InitiativeEndDate,
                AnnualMonetarySaving,
                PaybackPeriod,
                RequiredInvestment,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved: value,
                DateAchieved,
              };
              const result = onChange(modelFields);
              value = result?.GrossEmissionReductionAchieved ?? value;
            }
            if (errors.GrossEmissionReductionAchieved?.hasError) {
              runValidationTasks("GrossEmissionReductionAchieved", value);
            }
            setGrossEmissionReductionAchieved(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "GrossEmissionReductionAchieved",
              GrossEmissionReductionAchieved
            )
          }
          errorMessage={errors.GrossEmissionReductionAchieved?.errorMessage}
          hasError={errors.GrossEmissionReductionAchieved?.hasError}
          {...getOverrideProps(overrides, "GrossEmissionReductionAchieved")}
        ></TextField>
        <TextField
          label="Date achieved"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={DateAchieved}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                ReductionInitiativeName,
                ReductionInitiativeStatus,
                ReductionInitiativeDescription,
                EmissionReductionUnit,
                EmissionReductionValue,
                EstimatedAnnualCO2Saving,
                CO2SavingScope,
                InitiativeStartDate,
                InitiativeEndDate,
                AnnualMonetarySaving,
                PaybackPeriod,
                RequiredInvestment,
                EstimatedInitiativeLifetime,
                GrossEmissionReductionAchieved,
                DateAchieved: value,
              };
              const result = onChange(modelFields);
              value = result?.DateAchieved ?? value;
            }
            if (errors.DateAchieved?.hasError) {
              runValidationTasks("DateAchieved", value);
            }
            setDateAchieved(value);
          }}
          onBlur={() => runValidationTasks("DateAchieved", DateAchieved)}
          errorMessage={errors.DateAchieved?.errorMessage}
          hasError={errors.DateAchieved?.hasError}
          {...getOverrideProps(overrides, "DateAchieved")}
        ></TextField>
      </Grid>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
